<div class="m-2">
  <div class="modal-header text-center">
    <h4 class="modal-title">Are you sure {{eligiblePet.name}} wouldn’t benefit from 4 weeks free pet insurance from Petplan?</h4>
  </div>
  <div class="modal-footer d-flex justify-content-center text-center">
    <button type="button" class="btn btn-lg btn-success text-white" (click)="activeModal.close(true)">Insure {{eligiblePet.name}}</button>
    <button type="button" class="btn btn-lg button-background-color text-white" (click)="activeModal.close(false)">Don't insure {{eligiblePet.name}}</button>
  </div>
</div>
